// extracted by mini-css-extract-plugin
export var chip = "_gv-0";
export var filterDropdown = "_gv-5";
export var filterItem = "_gv-6";
export var icon = "_gv-1";
export var removeButton = "_gv-3";
export var removeIcon = "_gv-4";
export var separator = "_gv-2";